import moment from "moment";
import loginedApi from "../apis";
import authHeader from './auth-header';
import { FETCH_COUNTRYDATA, DASHBOARD_DATA_DOCTOR, TODAY_APPOINTMENT_DOCTOR, ACCEPT_REQUEST, REJECT_REQUEST} from "./type";
import CryptoJS from "crypto-js";
  var hashcode = CryptoJS.SHA256(process.env.REACT_APP_PREFIX+process.env.REACT_APP_TOKEN+process.env.REACT_APP_SECRETKEY);

const publicIp = require("public-ip");
const { detect } = require('detect-browser');
const browser = detect();
let IP = publicIp.v4();
let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;

let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B")
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D")
}

export const getCountryData = () => async (dispatch) => {
  
  const res = await loginedApi.post("getcountrycode", 
  {
    token :hashcode.toString(),
    "version":"2.0",
    "data": {"browserTimeZone":"GMT%2B05:30"},
    "requestType": 1058
});

  if (res.status === 200) {

    dispatch({ type: FETCH_COUNTRYDATA, payload: res.data.data });
  }


};


//This API call is used to fetch the Doctor's requested appointments from DB
export const fetch_doctor_appointment_requests = (doctorid) => async (dispatch) => {
  console.log("Inside fetch_dr_apt_details")    
  let resp = await loginedApi.post("getcountrycode", 
  {
    token :hashcode.toString(),
    "version":"2.0",
    "data": {"browserTimeZone":"GMT%2B05:30"},
    "requestType": 1058
  });

 const doctorscountrycode = resp.data.data;

  let data = {
    accessCountry: doctorscountrycode.Country,
    browserTimeZone: `GMT${formatTime}`,
    currency: doctorscountrycode.currency,
    doctorId: doctorid,
    todayRate: "74.45000",
    Ipaddress: doctorscountrycode.Ipaddress, 
    Os: platform,
    useragent: userAgent,    
  }
 const response = await loginedApi.post("getappointmentdetails", {
    requestType: "800",
   token :hashcode.toString(),
    data
  },{ headers: authHeader() });
  
  console.log( "DOCTOR's data fetched!!!" ,response);
  if (response.status === 200) {
    dispatch({ type: DASHBOARD_DATA_DOCTOR, payload: response.data.data });
  }  
  return response.data.data;
};

//This API call is used to fetch the Doctor's today's appointment from DB
export const fetch_doctor_today_appointment = (doctorid) => async (dispatch) => {
  console.log("Inside fetch_doctor_today_appointment")
  let today = moment(new Date()).format("DD-MMM-YYYY")    
  let resp = await loginedApi.post("getcountrycode", 
  {
    token :hashcode.toString(),
    "version":"2.0",
    "data": {"browserTimeZone":"GMT%2B05:30"},
    "requestType": 1058
  });
const doctorscountrycode = resp.data.data; 
  let data = {
    appointmentNavigation : "",
    browserTimeZone : `GMT${formatTime}`,
    dayOfAppointment : today,
    doctorId: doctorid,
    Ipaddress: doctorscountrycode.Ipaddress, 
    Os: platform,
    // accessCountry: doctorscountrycode.Country, 
    useragent: userAgent,    
  }

  try {
     const response = await loginedApi.post(
       "appointments",
       {
         requestType: 116,
         token: hashcode.toString(),
         data,
       },
       { headers: authHeader() }
     );
     console.log("Printing Dr's today's appointments", response.data.data);

     if (response.status === 200) {
       dispatch({
         type: TODAY_APPOINTMENT_DOCTOR,
         payload: response.data.data,
       });
     }
     return response.data.data;
    
  } catch (error) {
    console.log("🚀 ~ constfetch_doctor_today_appointment= ~ error:", error)
    
  }
 
};

//This function is to fetch the API details for the doctor to accept the patient request
export const acceptPatientRequest = ({ appointmentId, appointmentDate, appointmentTime}) => async (dispatch) => {
    let alternateDate = appointmentDate + " " + appointmentTime;
    let resp = await loginedApi.post("getcountrycode", 
    {
      token :hashcode.toString(),
      "version":"2.0",
      "data": {"browserTimeZone":"GMT%2B05:30"},
      "requestType": 1058
     });
    const doctorscountrycode = resp.data.data;
    const res = await loginedApi.post("getappointmentdetails",
        {
            "requestType": 600,
            "token": "C2MDVerificationToken",
            "data": {
                "alternateDate" : alternateDate,
                "appointmentId" : appointmentId,
                 browserTimeZone : `GMT${formatTime}`,
                "cancelledBy" : "Doctor",
                "process" : "accept",
                 Ipaddress: doctorscountrycode.Ipaddress,
                 Os: platform,
                useragent: userAgent,
            }
        }
    );
    console.log("Inside acceptPatientRequest - appointmentdetails fetched",res.data.data)   
    if (res.status === 200) {
        dispatch({
            type: ACCEPT_REQUEST,
            payload: res.data.data,
        });        
    }
    return res.data.data;
};

//This function is to fetch the API details for the doctor to reject the patient request
export const rejectPatientRequest = ({ appointmentId, reasonForCancel }) => async (dispatch) => {
    console.log("Inside rejectPatientRequest in DoctorAppointmentActions.js")
    let resp = await loginedApi.post("getcountrycode", 
    {
      token :hashcode.toString(),
      "version":"2.0",
      "data": {"browserTimeZone":"GMT%2B05:30"},
      "requestType": 1058
     });
    const doctorscountrycode = resp.data.data;
    const res = await loginedApi.post("getappointmentdetails",
        {
            "requestType": 600,
            "token": "C2MDVerificationToken",
            "data": {
                "alternateDate" : "",
                "alternateTime" : "",
                "appointmentId" : appointmentId,
                 browserTimeZone : `GMT${formatTime}`,                 
                "cancelledBy" : "Doctor",
                "message" : "nill",
                "process" : "cancel",
                "reasonForCancel" : reasonForCancel,
                 Ipaddress: doctorscountrycode.Ipaddress,
                 Os: platform,
                 useragent: userAgent,
            }
        }
    );
   if (res.status === 200) {
        dispatch({
            type: REJECT_REQUEST,
            payload: res.data.data,
        });
    }
};


export const fetch_doctor_patientList = (doctorid) => async (dispatch) => {
  console.log("Inside fetch_doctor_today_appointment")
  let today = moment(new Date()).format("DD-MMM-YYYY")    
  let resp = await loginedApi.post("getcountrycode", 
  {
    token :hashcode.toString(),
    "version":"2.0",
    "data": {"browserTimeZone":"GMT%2B05:30"},
    "requestType": 1058
  });
const doctorscountrycode = resp.data.data; 
  let data = {
   
    browserTimeZone : `GMT${formatTime}`,
    selectType : "",
    doctorId: doctorid,
    Ipaddress: doctorscountrycode.Ipaddress, 
    Os: platform,
    // accessCountry: doctorscountrycode.Country, 
    useragent: userAgent,    
  }
  const response = await loginedApi.post("profile", {
    requestType: 107,
   token :hashcode.toString(),
    data
  },{ headers: authHeader() });
  console.log("Printing Dr's today's appointments",response.data.data)

  if (response.status === 200) {
   // dispatch({ type: TODAY_APPOINTMENT_DOCTOR, payload: response.data.data });   
  }
  return response.data.data;
};